function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });
	
  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    //this.addEventListener('load', this.onVariantChange);
  }

  onVariantChange(e) {
    //console.log(e);
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if(e.target.value == '4 x AccuBow 2.0'){
      var fmods = document.querySelector('.Model20');	
      fmods.click();
    }
    if(e.target.value == '4 x AccuBow 1.0'){
      var fmods = document.querySelector('.Model10');	
      fmods.click();
    }
    if(e.target.value == '4 x AccuBow Nano'){
      var fmods = document.querySelector('.ModelNano');	
      fmods.click();
    }
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {      
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if(this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => {
      parent.scrollLeft = 0;
      parent.querySelector('li.product__media-item').scrollIntoView({behavior: 'smooth'});
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      //console.log(this.currentVariant.available+' '+this.currentVariant.title);

      
      
      if(this.currentVariant.title.indexOf("2.0") !== -1){
      var all = document.querySelectorAll('.product-form__Model label');  
      all.forEach((al) => {
        al.style.display = 'none';
      });
        var fmods = document.querySelector('.Model20');
	var mods = document.querySelectorAll('.Model20');
        //fmods.click();
        mods.forEach((mod) => {
          mod.style.display = 'inline-block';
        });        
        //var sale = document.getElementById('bsale');
        //var html = '<s class="price-item price-item--regular">$800.00 640 280</s>';
//sale.innerHTML = '$800.00'
        
}
        if(this.currentVariant.title.indexOf("1.0") !== -1){
          var all = document.querySelectorAll('.product-form__Model label');  
      all.forEach((al) => {
        al.style.display = 'none';
      });
          var fmods = document.querySelector('.Model10');
       var mods = document.querySelectorAll('.Model10');
          //fmods.click();
        mods.forEach((mod) => {
          mod.style.display = 'inline-block';
        }); 
}
          if(this.currentVariant.title.indexOf("AccuBow Nano") !== -1){
            var all = document.querySelectorAll('.product-form__Model label');  
      all.forEach((al) => {
        al.style.display = 'none';
      });
            var fmods = document.querySelector('.ModelNano');
     var mods = document.querySelectorAll('.ModelNano');
            //fmods.click();
        mods.forEach((mod) => {
          mod.style.display = 'inline-block';
        });   
}
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    
    
    if (this.currentVariant && this.currentVariant.available) {
      if (variantStock[this.currentVariant.id] > 0 && this.currentVariant.inventory_management == 'shopify') {
      
      }else{
      //document.getElementById('vavailability').innerHTML = 'SOLD OUT - Back Ordered Until Late-March of 2023';  
      }
      document.getElementById('vavailability').innerHTML = '<span class="x">In Stock</span> - Available for immediate shipping';
      
      document.getElementById('vavailability').classList.remove("nostock");
      document.getElementById('vavailability').classList.add("instock");
      
      //document.getElementById('mavailability').innerHTML = '<span>In Stock</span> - Available for immediate shipping';
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      document.getElementById('vavailability').classList.add("nostock");
      document.getElementById('vavailability').classList.remove("instock");
      
      document.getElementById('vavailability').innerHTML = 'Sold Out - Out of Stock';
      //document.getElementById('mavailability').innerHTML = 'Sold Out - Out of Stock';
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
       
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => { console.log(responseText);
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      
      /*var els = document.querySelectorAll('.product-form__input input[type=radio]:checked');
        for(var i = 0; i< els.length; i++){
          var el = document.querySelector("#"+els[i].id).parentNode;
          console.log(el.querySelector("label"));
          //el.querySelector("label").classList.remove('soldout');
          //el.querySelector("label").classList.add('available');
        }*/
     
    } else {
      addButton.removeAttribute('disabled');      
      addButtonText.textContent = window.variantStrings.addToCart;
      /*if (variantStock[this.currentVariant.id] <= 0 && this.currentVariant.inventory_management == 'shopify') {
        addButton.classList.add('product-form_preorder');
      addButtonText.textContent = window.variantStrings.preorder;
      }else{
        addButton.classList.remove('product-form_preorder');
        addButtonText.textContent = window.variantStrings.addToCart;
      }*/
    }

    if (!modifyClass) return;

    const variantmetafield = document.getElementById('hidden-current-variant-metafield').textContent;
    if(variantmetafield == 'true'){
      productForm.querySelector('.buynow-btn').innerHTML = '<span>Pre-Order</span>';
      document.getElementById('sticky-info').querySelector('.buynow-btn').innerHTML = '<span>Pre-Order</span>';      
      document.getElementById('vavailability').innerHTML = 'DUE TO SUCH HIGH DEMAND, PRE-ORDERS ARE ESTIMATED TO SHIP OUT LATE-JANUARY';    
    }else{
      productForm.querySelector('.buynow-btn').innerHTML = '<span>Buy Now</span>';
      document.getElementById('sticky-info').querySelector('.buynow-btn').innerHTML = '<span>Buy Now</span>';
      updatePickupAvailability()
    }
    
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

var tybutton = document.querySelector('.tybutton'); 
if(tybutton){
  tybutton.addEventListener('click', function(){
    window.localStorage.setItem("code", "true");
  });
}

/*var myDiv = document.querySelector('.product__info-container--sticky');
window.onscroll = function() {
    let d = document.querySelector('.product__info-container--sticky');
    let offset = d.scrollTop + window.innerHeight;
    let height = d.offsetHeight;
var scrollBarPosition = window.pageYOffset | document.body.scrollTop;
    console.log(scrollBarPosition);
    console.log('height = ' + height);

    if (offset >= height) {
        console.log('At the bottom');
    }
};*/
/*document.getElementById('Banner-template--14241042759724__164395131752ee6fca').insertAdjacentHTML("afterbegin","<img src='https://emailtaco.com/1653368340000.gif' id='taccoimage'>");*/

function instantBuy(e,atcform){ 
  e.preventDefault();
  let atc_form = document.getElementById(atcform); 
  let variantId = atc_form.querySelector('input[name="id"]').getAttribute('value');  console.log(variantId);

  let formData = {
 'items': [{
  'id': variantId,
  'quantity': 1
  }]
};

    fetch('/cart/add', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    }).then(function (response) {
        if (response.ok) {
            location.href='/checkout';
            return response.json();
        }
        throw response;
    }).then(function (data) {
        console.log(data);
    }).catch(function (error) {
        console.warn(error);
    });
}

function instantBuyWithCoupon(e,atcform){ 
  e.preventDefault();  
  let variantId = atcform;  console.log(variantId);

  let formData = {
 'items': [{
  'id': variantId,
  'quantity': 1
  }]
};

    fetch('/cart/add', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    }).then(function (response) {      
        if (response.ok) {
            applyCoupon();
            location.href='/checkout';
            return response.json();
        }
        throw response;
    }).then(function (data) {
        console.log(data);
    }).catch(function (error) {
        console.warn(error);
    });

  const COUPON_CODE = "ACCU20";
  function applyCoupon() {    
    fetch('/discount/' + COUPON_CODE, {
      method: 'GET'
    })
    .then(response => {      
      window.location.href = '/checkout';
    })
    .catch(error => {
      console.error('Error applying coupon:', error);
      window.location.href = '/cart';
    });
  }
}


function videoLoadNew(element) {
    element.addEventListener('click', function () {
      // Hide clicked element
      element.style.display = 'none';

      // Remove previous sibling button if exists
      const prevButton = element.previousElementSibling;
      if (prevButton && prevButton.tagName.toLowerCase() === 'button') {
        prevButton.remove();
      }

      // Get the target video
      const targetVideo = element.nextElementSibling;
      if (targetVideo && targetVideo.tagName.toLowerCase() === 'video') {
        // Pause and reset all other videos on the page
        const allVideos = document.querySelectorAll('video');
        allVideos.forEach((video) => {
          if (video !== targetVideo) {
            video.pause();
            video.currentTime = 0;
          }
        });

        // Play the clicked video's associated video
        targetVideo.play();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function (event) {
    var video = document.getElementsByClassName('html_video_block_thumb');
    for (var i = 0, length = video.length; i < length; i++) {
      new videoLoadNew(video[i]);
    }
  });

  // sliders
  function initLogoFlickity() {
  var isMobile = window.matchMedia("(max-width: 991px)").matches; console.log(isMobile);
  var logoSliderSelector = document.querySelector('.ac_sale_logos_wrap');
if(logoSliderSelector){
  if (window.flkty) {
    window.flkty.destroy();
  }

  window.flkty = new Flickity(logoSliderSelector, {
    autoPlay: isMobile ? 4000 : false,
    resize: true,pauseAutoPlayOnHover: false,
    draggable: true,
    freeScroll: false,
    contain: false,
    wrapAround: true,
    adaptiveHeight: true,
    prevNextButtons: false,
    imagesLoaded: true,
    cellAlign: 'left',
    pageDots: false,
    percentPosition: true,
  });
  }
}
initLogoFlickity();
window.addEventListener('resize', initLogoFlickity);

  var videoSliderSelector = document.querySelector('.ac_sale_video_slider');
  if(videoSliderSelector){
  var videoSlider = new Flickity(videoSliderSelector, {
    //autoPlay: 2000,
    resize: true,
    draggable: true,
    freeScroll: true,
    contain: false,
    wrapAround: true,
    adaptiveHeight: true,
    prevNextButtons: true,
    imagesLoaded: true,
    cellAlign: 'left',
    pageDots: false,
    percentPosition: true,
  });
  }

  var huntSliderSelector = document.querySelector('.ac_sale_hunt_slider');
  if(huntSliderSelector){
  var huntSlider = new Flickity(huntSliderSelector, {
    autoPlay: 3000,
    resize: true,
    draggable: true,
    freeScroll: true,
    contain: false,
    wrapAround: true,
    adaptiveHeight: true,
    prevNextButtons: true,
    imagesLoaded: true,
    cellAlign: 'left',
    pageDots: false,
    percentPosition: true,
  });
}

  var testimonialSliderSelector = document.querySelector('.ac_sale_testimonial_slider');
  if(testimonialSliderSelector){
  var testimonialSlider = new Flickity(testimonialSliderSelector, {
    autoPlay: 6000,
    resize: true,
    draggable: true,
    freeScroll: true,
    contain: false,
    wrapAround: true,
    adaptiveHeight: false,
    prevNextButtons: true,
    imagesLoaded: true,
    cellAlign: 'left',
    pageDots: false,
    percentPosition: true,
  });
}

  //Accordions
  var accItem = document.getElementsByClassName('accordionItem');
  var accHD = document.getElementsByClassName('accordionItemHeading');
  for (i = 0; i < accHD.length; i++) {
    accHD[i].addEventListener('click', toggleItem, false);
  }
  function toggleItem() {
    var itemClass = this.parentNode.className;
    for (i = 0; i < accItem.length; i++) {
      accItem[i].className = 'accordionItem close';
    }
    if (itemClass == 'accordionItem close') {
      this.parentNode.className = 'accordionItem open';
    }
  }

// Countdown
function startCountdown(wrapper) {
  const countdownKey = 'countdownStartTime';

  function setNewStartTime() {
    const newStart = Date.now();
    sessionStorage.setItem(countdownKey, newStart);
    return newStart;
  }

  let startTime = sessionStorage.getItem(countdownKey);
  if (!startTime) {
    startTime = setNewStartTime();
  } else {
    startTime = parseInt(startTime, 10);
  }

  let endTime = startTime + 10 * 60 * 1000; // 10 minutes
  wrapper.dataset.end = new Date(endTime).toISOString();

  const daysSpan = wrapper.querySelector('.days');
  const hoursSpan = wrapper.querySelector('.hours');
  const minutesSpan = wrapper.querySelector('.minutes');
  const secondsSpan = wrapper.querySelector('.seconds');

  let timer;

  function updateCountdown() {
    const now = Date.now();
    let distance = endTime - now;

    if (distance <= 0) {
      // Restart timer
      startTime = setNewStartTime();
      endTime = startTime + 10 * 60 * 1000;
      distance = endTime - now;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    daysSpan.innerText = String(days).padStart(2, '0');
    hoursSpan.innerText = String(hours).padStart(2, '0');
    minutesSpan.innerText = String(minutes).padStart(2, '0');
    secondsSpan.innerText = String(seconds).padStart(2, '0');
  }

  updateCountdown(); // Initial run
  timer = setInterval(updateCountdown, 1000);
}

// Start countdown for all wrappers on the page
document.querySelectorAll('.ac_sale_countdown_wrapper').forEach(startCountdown);

